<template>
  <div class="commodityBody">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="cardheader">
          <el-select
            size="mini"
            v-model="commodityType"
            @change="commodityTypeChange"
            placeholder="请选择"
          >
            <el-option
              v-for="item in commodityTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button type="text" @click="openAddgoodsPop">添加商品</el-button>
        </div>
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%" height="600">
          <el-table-column prop="commodityName" label="商品名称"></el-table-column>
          <el-table-column prop="name" label="商品图片">
            <template slot-scope="scope">
              <img :src="scope.row.commodityPic" style="wdith:50px;height:50px" alt />
            </template>
          </el-table-column>
          <el-table-column prop="commodityPrice" label="价格"></el-table-column>
          <el-table-column prop="commodityStock" label="库存"></el-table-column>
          <el-table-column prop="commodityType" label="类别"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openEditPopBox(scope.row)">修改</el-button>
              <el-button
                style="margin-left:15px"
                type="text"
                size="small"
                @click="delGoodsData(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
            <el-dialog title="上架商品" :visible.sync="isShowAddPop" width="30%">
          <div class="editMainBox">
            <div class="editMainItem">
              <div class="editMainItemLeft">商品图片：</div>
              <div class="editMainItemright">
                <img style="width:50px;height:50px" v-show="addGoodImgUrl!=''" :src="addGoodImgUrl" alt />
                <el-upload
                  style="margin-left:20px"
                  class="upload-demo"
                  action="https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture"
                  :auto-upload="true"
                  multiple
                  :on-success="fileDataChange2"
                  :show-file-list="false"
                  :limit="1"
                >
                  <el-button size="small" type="primary">上传图片</el-button>
                </el-upload>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">商品名称：</div>
              <div class="editMainItemright">
                <el-input v-model="addcomName" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">商品价格：</div>
              <div class="editMainItemright">
                <el-input v-model="addcomPrice" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">库存数量：</div>
              <div class="editMainItemright">
                <el-input v-model="addcomStroe" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">商品类型：</div>
              <div class="editMainItemright">
                 <el-select v-model="addcomType" placeholder="请选择">
    <el-option
      v-for="item in columns"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
                <!-- <el-input v-model="addcomType" placeholder="请输入内容"></el-input> -->
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShowAddPop = false">取 消</el-button>
            <el-button type="primary" @click="submitAddgoods">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="商品信息修改" :visible.sync="isShowEditBox" width="30%">
          <div class="editMainBox">
            <div class="editMainItem">
              <div class="editMainItemLeft">商品图片：</div>
              <div class="editMainItemright">
                <img style="width:50px;height:50px" :src="changeImgUrl" alt />
                <el-upload
                  style="margin-left:20px"
                  class="upload-demo"
                  action="https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture"
                  :auto-upload="true"
                  multiple
                  :on-success="fileDataChange"
                  :show-file-list="false"
                  :limit="1"
                >
                  <el-button size="small" type="primary">修改图片</el-button>
                </el-upload>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">商品名称：</div>
              <div class="editMainItemright">
                <el-input v-model="comName" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">商品价格：</div>
              <div class="editMainItemright">
                <el-input v-model="comPrice" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">库存数量：</div>
              <div class="editMainItemright">
                <el-input v-model="comStroe" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="editMainItem">
              <div class="editMainItemLeft">商品类型：</div>
              <div class="editMainItemright">
                <el-input v-model="comType" placeholder="请输入内容"></el-input>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShowEditBox = false">取 消</el-button>
            <el-button type="primary" @click="submitEditData">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId:"",
       columns: ['零食', '饮料', '生鲜', '日用', '烟草', '酒水', '粮油', '文具', '其他'],
      // visible: false,
      comPrice: 0,
      comStroe: 0,
      comType: "零食",
      isShowEditBox: false,
      tableData: [],
      commodityType: "全部",
      commodityTypeList: [
        {
          value: "全部",
          label: "全部"
        }
      ],
      isShowAddPop:false,
      commodityList: [],
      changeImgUrl: "",
      comName: "",
      comId: "",


      addGoodImgUrl:'',
      addcomName:"",
      addcomPrice:"",
      addcomStroe:"",
      addcomType:""
    };
  },
  mounted() {
    console.log(this.$store.state.userData);
    this.userId = this.$store.state.userData
    this.getTaleData();
  },
  methods: {
    submitAddgoods(){
      let formData = new FormData();

formData.append("commodity_name",this.addcomName);
formData.append("commodity_type",this.addcomType);
formData.append("commodity_pic", this.addGoodImgUrl);
formData.append("commodity_price", this.addcomPrice);
formData.append("commodity_stock", this.addcomStroe);
formData.append("merchant_id", this.userId);

       this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/pigbox/CommodityService/updateGoodsInfo`,
        data: formData
      }).then((res)=>{
        console.log(res);
        this.isShowAddPop = false
          this.getTaleData();
      })
    },
    openAddgoodsPop(){
      this.isShowAddPop=true
    },
    delGoodsData(id) {
      console.log(id);
      // return
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/pigbox/CommodityService/offShelfCommodity/${id}`
      }).then(res => {
        // console.log(res);
        this.getTaleData();
        this.$message({
          message: "删除成功",
          type: "success"
        });
      });
    },
    submitEditData() {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/pigbox/CommodityService/updateGoodsInfo`,
        data: {
          commodity_name: this.comName,
          commodity_type: this.comType,
          commodity_pic: this.changeImgUrl,
          commodity_price: this.comPrice,
          commodity_stock: this.comStroe,
          id: this.comId
        }
      }).then(res => {
        console.log(res);
        this.isShowEditBox = false;
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.getTaleData();
      });
    },
    fileDataChange(e) {
      console.log(e);
      this.changeImgUrl = `https://www.moodsci.com${e}`;
    },
    fileDataChange2(e) {
      console.log(e);
      this.addGoodImgUrl = `https://www.moodsci.com${e}`;
    },
    openEditPopBox(data) {
      console.log(data);
      this.changeImgUrl = data.commodityPic;
      this.comType = data.commodityType;
      this.comStroe = data.commodityStock;
      this.comName = data.commodityName;
      this.comPrice = data.commodityPrice;
      this.comId = data.id;
      // this.comPrice = data.commodityPrice
      this.isShowEditBox = true;
    },
    commodityTypeChange(data) {
      // console.log(data);
      if (data == "全部") {
        this.tableData = this.commodityList;
      } else {
        this.tableData = this.commodityList.filter(el => {
          return el.commodityType == data;
        });
      }
    },
    getTaleData() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/pigbox/CommodityService/getMerchantAllGoods/${this.userId}`
      }).then(res => {
        console.log(res.data);
        // console.log(Object.keys(res.data));
        let keyList = Object.keys(res.data);
        keyList.map(item => {
          this.commodityList.push(...res.data[item]);
          this.commodityTypeList.push({
            value: item,
            label: item
          });
        });
        console.log(this.commodityList);
        this.tableData = this.commodityList;
        // this.commodityList = res.data
      });
    }
  }
};
</script>

<style>
.commodityBody {
  height: 100%;
  width: 100%;
}
.box-card {
  height: 100%;
}
.cardheader {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.editMainBox {
  height: 300px;
  width: 100%;
  /* background-color: aqua; */
}
.editMainItem {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 15px;
}
.editMainItemLeft {
  height: 50px;
  width: 20%;
  line-height: 50px;
}
.editMainItemright {
  height: 50px;
  width: 70%;
  text-align: left;
  display: flex;
  align-items: center;
}
</style>